import { render, staticRenderFns } from "./practice_weixin.vue?vue&type=template&id=69d22c0c&scoped=true&"
import script from "./practice_weixin.vue?vue&type=script&lang=js&"
export * from "./practice_weixin.vue?vue&type=script&lang=js&"
import style0 from "./practice_weixin.vue?vue&type=style&index=0&id=69d22c0c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d22c0c",
  null
  
)

export default component.exports